module.exports = __webpack_public_path__ + "static/img/frame_vmgc.b342b1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certificate/frame_vmgc.png
// module id = g5RQ
// module chunks = 1